import SVErrorPage from '@apps/www/src/www/pages/SVErrorPage';
import Head from 'next/head';

const SV404Page = () => (
	<>
		<Head>
			<meta name="robots" content="noindex" />
		</Head>
		<SVErrorPage statusCode={404} />
	</>
);

export default SV404Page;
